import { render, staticRenderFns } from "./qEventItemPaginate.vue?vue&type=template&id=0b400186&scoped=true&"
import script from "./qEventItemPaginate.vue?vue&type=script&lang=ts&"
export * from "./qEventItemPaginate.vue?vue&type=script&lang=ts&"
import style0 from "./qEventItemPaginate.vue?vue&type=style&index=0&id=0b400186&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b400186",
  null
  
)

export default component.exports